import { Action, createReducer, on } from '@ngrx/store';
import { BannerActions, RetryActions, GtmActions } from '../actions';
import { ApplicationState, IRetryAction, isRetryAction } from '../types';

export const initialState: ApplicationState = {
  banner: {
    title: '',
    description: '',
    isEnabled: false,
  },
  gtmEnabled: false,
  actionsToRetry: [],
};

export const FEATURE_NAME_CORE = 'core';

const reducer = createReducer(
  initialState,
  on(BannerActions.dismissBanner, (state) => ({
    ...state,
    banner: {
      ...state.banner,
      isEnabled: false,
    },
  })),
  on(BannerActions.setBannerDetail, (state, { bannerDetails }) => ({
    ...state,
    banner: {
      ...bannerDetails,
    },
  })),
  on(BannerActions.setBannerDetail, (state, { bannerDetails }) => ({
    ...state,
    banner: {
      ...bannerDetails,
    },
  })),
  on(GtmActions.setGtmEnabled, (state, { isEnabled }) => ({
    ...state,
    gtmEnabled: isEnabled,
  })),
  on(RetryActions.clearRetryFailedActions, (state) => ({
    ...state,
    actionsToRetry: [],
  }))
);

export function coreReducer(
  state: ApplicationState,
  action: Action | (Action & IRetryAction)
): ApplicationState {
  //Store last action if action is marked as one to be saved for retry

  let newState: ApplicationState =
    state && isRetryAction(action) && action.retryAction
      ? {
          ...state,
          actionsToRetry: [
            ...(state?.actionsToRetry || []),
            action.retryAction,
          ],
        }
      : {
          ...state,
        };

  return reducer(newState, action);
}
